export default __webpack_public_path__ + "static/media/diagram.565647f5.jpeg";